import { EnterpriseLink } from 'components/EnterpriseLink';
import type { InvoiceDirection } from 'modules/invoicing/common/types';
import type { RowInvoiceState } from 'modules/linker/types';
import { formatDate, sepFormat } from 'utilities';
import { amountContainer, container, dateContainer, numberContainer } from './SourceInvoice.css';

type SourceInvoiceProps = {
  invoice: RowInvoiceState;
  direction: InvoiceDirection;
};

export function SourceInvoice({ invoice: { id, number, checkout_date, amount }, direction }: SourceInvoiceProps) {
  return (
    <div className={container}>
      <EnterpriseLink to={`/invoices/${direction}/${id}`} className={numberContainer}>
        {number}
      </EnterpriseLink>
      <span className={dateContainer}>{formatDate(checkout_date)}</span>
      <span className={amountContainer}>{sepFormat(amount)}</span>
    </div>
  );
}
